module.exports = __webpack_public_path__ + "officialStatic/img/case46.51ae045.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partner/case46.jpg
// module id = HDeh
// module chunks = 0